import React, { useEffect, useRef, forwardRef, useState } from "react";
import { makeStyles, Box, Button } from "@material-ui/core";
import moment from "moment";
import ArrowRightIcon from "mdi-react/ArrowRightIcon";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../../MarketPulse/components/CustomDate/range-picker.scss";


const useStyles = makeStyles((theme) => ({
  popupContainer: {
    width: "350px",
    height: "600px",
    backgroundColor: "black",
    // boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  popoverContent: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    backgroundColor: "#F6F8FA",
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    padding:"20px 26px"
  },
  arrowIcon: {
    margin: theme.spacing(0, 0),
  },
  button: {
    "&.selected": {
      background: "#EDDEF5",
    },
  },
  datePicker: {
    width: "100%",
    border: "1px solid #ced4da",
    borderRadius: "4px",
    padding: "8px",
  },
}));

const DateRangeComp = (
  (
    {
      startDate,
      endDate,
      setStartDate,
      setEndDate,
      showPopup,
      setShowPopup,
      setIsStartDateOpen,
      isStartDateOpen,
      setCurrentMonthYear,
      currentMonthYear,
      setSelectedOption,
      setFormValues,
      setStartDateError,
      setEndDateError,
      startDateError,
      endDateError,
      setCurentFormValues,
    },
  ) => {
    const classes = useStyles();
    const startDateRef = useRef();
    const endDateRef = useRef(); 

    const [localStartDate, setLocalStartDate] = useState(startDate);
    const [localEndDate, setLocalEndDate] = useState(endDate);
    
    useEffect(() => {
      if (localStartDate && localEndDate) {
        const formattedStartDate = `Choose ${localStartDate.format(
          "dddd, MMMM Do, YYYY"
        )}`;
        const formattedEndDate = `Choose ${localEndDate.format(
          "dddd, MMMM Do, YYYY"
        )}`;
        const allDates = document.querySelectorAll("[aria-label]");

        allDates.forEach((dateElement) => {
          const ariaLabel = dateElement.getAttribute("aria-label");
          dateElement.style.backgroundColor = "";
          dateElement.style.color = "";
          const dateFromAriaLabel = moment(
            ariaLabel.replace("Choose ", ""),
            "dddd, MMMM Do, YYYY"
          );
          const isBetween = dateFromAriaLabel.isBetween(
            localStartDate,
            localEndDate,
            null,
            "[]"
          );
          if (ariaLabel === formattedStartDate) {
            dateElement.style.backgroundColor = "#780f9e";
            dateElement.style.color = "white";
            dateElement.style.borderRadius = "4px";
          }
          if (ariaLabel === formattedEndDate) {
            dateElement.style.backgroundColor = "#780f9e";
            dateElement.style.color = "white";
            dateElement.style.borderRadius = "4px";
          }
          if (
            isBetween &&
            ariaLabel !== formattedStartDate &&
            ariaLabel !== formattedEndDate
          ) {
            if (dateElement.classList.contains("highlighted-date")) {
              dateElement.style.backgroundColor = "EDDEF5";
              dateElement.style.color = "white";
            }
          }
        });
      }
      // const removeKeyboardSelectedClass = () => {
      //   const keyboardSelectedDays = document.querySelectorAll(
      //     ".react-datepicker__day--keyboard-selected"
      //   );
      //   keyboardSelectedDays.forEach((day) => {
      //     day.classList.remove("react-datepicker__day--keyboard-selected");
      //   });
      // };

      // removeKeyboardSelectedClass();
      
    }, [
      localStartDate,
      localEndDate,
      isStartDateOpen,
      showPopup,
      currentMonthYear,
    ]);
    console.log(currentMonthYear, "currentMonthYear")
    const formats = [
      "MM/DD/YYYY",
      "MMDDYYYY",
      "M/D/YYYY",
      "MM-DD-YYYY",
      "M-D-YYYY",
      "M/D/YYYY",
    ];
    const specialChar = ["/", "-"];
    const submitHandler = () => {

      
      if (localStartDate && localEndDate) {
        setStartDate(localStartDate);
        setEndDate(localEndDate);
        setCurentFormValues &&    setCurentFormValues((prev) => ({
          ...prev,
          dateOptions: {
            ...prev.dateOptions,
            anyChangeOccured: true,
            startDate:localStartDate,
            endDate:localEndDate           
          },
        }))
        setSelectedOption  && setSelectedOption("Custom");
      }
      setShowPopup(null);
      setStartDateError("");
      setEndDateError("")
    };


    const handleCurrentStartDateChange = (date, event) => {
      console.log(date, event, "dateRange")
      if (date && event.type === "click") {
        if (moment(date).isAfter(localEndDate)) {
          setStartDateError("Start Date cannot be after end Date"); 
        } else {
          setLocalStartDate(moment(date));
          setIsStartDateOpen(false); 
          endDateRef &&   endDateRef.current &&    endDateRef.current.input && endDateRef.current.input.focus(); 
        }
      }
    };

    const handleCurrentEndDateChange = (date, event) => {
      if (date && event.type === "click") {
        const selectedEndDate = moment(date); 
        if (localStartDate && selectedEndDate.isBefore(localStartDate)) {
          setEndDateError("End Date cannot be before Start Date"); 
        } else {
          setLocalEndDate(selectedEndDate); 
          setEndDateError(""); 
        }
      }
    };

    const getDayClassName = (date) => {
      if (
        localStartDate &&
        localEndDate &&
        date >= localStartDate.toDate() &&
        date <= localEndDate.toDate()
      ) {
        return "highlighted-date";
      }
      return "";
    };

    const handleMonthYearChange = (date) => {
      setCurrentMonthYear(date);
      
    };

    const handleStartDateRawChange = (e) => {
      const value = e.target.value;
      console.log(value, "value");
      setStartDateError("");
      let formattedStartDate;
      // Check if the input matches the specific format of MMDDYYYY
      if (/^\d{8}$/.test(value)) {
        const formattedValue = `${value.slice(0, 2)}/${value.slice(
          2,
          4
        )}/${value.slice(4)}`;
        formattedStartDate = moment(formattedValue, formats, true);

        if (formattedStartDate.isValid()) {
          const formattedDateString = formattedStartDate.format("MM/DD/YYYY");
          e.target.value = formattedDateString;

          if (formattedStartDate.isAfter(localEndDate)) {
            setStartDateError("Start Date cannot be after End Date");
          } else {
            setLocalStartDate(formattedStartDate);
            setIsStartDateOpen(false);
            setStartDateError("");
          }
        } else {
          setStartDateError("Invalid Date Format");
        }
      } else {
        formattedStartDate = moment(value, formats, true);
        if (formattedStartDate.isValid()) {
          const formattedDateString = formattedStartDate.format("MM/DD/YYYY");
          e.target.value = formattedDateString;

          if (formattedStartDate.isAfter(localEndDate)) {
            setStartDateError("Start Date cannot be after End Date");
          } else {
            setLocalStartDate(formattedStartDate);
            setStartDateError("");
            setIsStartDateOpen(false);
          }
        } else if (value.length >= 10 && checkSpecialCharacters(value)) {
          setStartDateError("Invalid Date Format");
        } else if (value.length >= 6 && !checkSpecialCharacters(value)) {
          setStartDateError("Invalid Date, Format should be MM/DD/YYYY");
        }
      }
    };

    const handleEndDateRawChange = (e) => {
      const value = e.target.value;
      setEndDateError("");
      let formattedEndDate;
      if (/^\d{8}$/.test(value)) {
        const formattedValue = `${value.slice(0, 2)}/${value.slice(
          2,
          4
        )}/${value.slice(4)}`;
        formattedEndDate = moment(formattedValue, "MM/DD/YYYY", true);

        if (formattedEndDate.isValid()) {
          const formattedDateString = formattedEndDate.format("MM/DD/YYYY");
          e.target.value = formattedDateString;

          if (formattedEndDate.isBefore(localStartDate)) {
            setEndDateError("End Date cannot be before Start Date");
          } else {
            setLocalEndDate(formattedEndDate);
            setEndDateError("");
          }
        } else {
          setEndDateError("Invalid End Date Format");
        }
      } else {
        formattedEndDate = moment(value, formats, true);

        if (formattedEndDate.isValid()) {
          const formattedDateString = formattedEndDate.format("MM/DD/YYYY");
          e.target.value = formattedDateString;

          if (formattedEndDate.isBefore(localStartDate)) {
            setEndDateError("End Date cannot be before Start Date");
          } else {
            setLocalEndDate(formattedEndDate);
            setEndDateError("");
          }
        } else if (value.length >= 10 && checkSpecialCharacters(value)) {
          setEndDateError("Invalid Date Format");
        } else if (value.length >= 6 && !checkSpecialCharacters(value)) {
          setEndDateError("Invalid Date, Format should be MM/DD/YYYY");
        }
      }
    };

    const checkSpecialCharacters = (value) => {
      return specialChar.some((char) => value.includes(char));
    };
    useEffect(()=>{
      if(startDate && endDate && setFormValues){
        setFormValues((prevState) => ({
          ...prevState,
          dateOptions: {
            ...prevState.dateOptions,
            isCustomPreviousSelected:true,
            isPreviousSelectedClicked:false,
            anyChangeOccured:true
            

          },
        }));
      }
    },[startDate, endDate])
    const handleCalendarOpen = () => {
      console.log("Date Picker closed");
 setStartDateError("");
 setEndDateError("")
    };
    return (
      <Box className={classes.popoverContent}>
        <div
          className={`custom-datepicker-container ${
            startDateError ? "custom_error" : ""
          }`}
          id={`${isStartDateOpen ? "start_picker_focus" : ""}`}
        >
          <ReactDatePicker
            selected={localStartDate ? localStartDate.toDate() : null}
            onChange={(date, e) => {
              if (e.type === "click") {
                
                setStartDateError("")
                const momentDate = moment(date);
                handleCurrentStartDateChange(momentDate, e);
              }
            }}
            ref={startDateRef}
            dateFormat="MM/dd/yyyy"
            placeholderText="Start Date"
            className="custom-datepicker"
            autoComplete="off"
            maxDate={new Date()}
            open={isStartDateOpen}
            onInputClick={() => {
              setIsStartDateOpen(true);
            }}
            autoFocus={isStartDateOpen}
            dayClassName={getDayClassName}
            onMonthChange={handleMonthYearChange}
            onYearChange={handleMonthYearChange}
            showYearDropdown
            showMonthDropdown
            readOnly={!isStartDateOpen}
            onChangeRaw={handleStartDateRawChange}
            onCalendarOpen={handleCalendarOpen}
          
          />
          {startDateError ? (
            <span className="error">{startDateError}</span>
          ) : null}
        </div>
        <ArrowRightIcon className={classes.arrowIcon} />
        <div
          className={`custom-datepicker-container ${
            endDateError ? "custom_error" : ""
          }`}
          id={`${!isStartDateOpen ? "end_picker_focus" : ""}`}
        >
          <ReactDatePicker
            selected={localEndDate ? localEndDate.toDate() : null}
            onChange={(date, e) => {
              setEndDateError("")
              handleCurrentEndDateChange(date, e);
            }}
            ref={endDateRef} 
            dateFormat="MM/dd/yyyy"
            placeholderText="End Date"
            className="custom-datepicker"
            maxDate={new Date()}
            readOnly={isStartDateOpen}
            minDate={localStartDate ? localStartDate.toDate() : null}
            autoComplete="off"
            onInputClick={() => {
              setIsStartDateOpen(false);
            }}
            open={!isStartDateOpen}
            autoFocus={!isStartDateOpen}
            dayClassName={getDayClassName}
            onMonthChange={handleMonthYearChange}
            onYearChange={handleMonthYearChange}
            showYearDropdown
            showMonthDropdown
            onChangeRaw={handleEndDateRawChange}
            onCalendarOpen={handleCalendarOpen}
          />
          {endDateError ? <span className="error">{endDateError}</span> : null}
        </div>

        <Button
          style={{
            position: "absolute",
            bottom: "10px",
            right: "10px",
            background: "#780f9e",
            color: "#fff",
          }}
          onClick={submitHandler}
        >
          Apply
        </Button>
      </Box>
    );
  }
);

export default DateRangeComp;
